const API_URL = "https://api.exchangerate-api.com/v4/latest/USD"; // Works with NGN and no API key needed

let exchangeRates = {}; // Store exchange rates in memory


export const fetchExchangeRates = async () => {
  try {
    const response = await fetch(API_URL);
    const data = await response.json();

    if (data && data.rates) {
      exchangeRates = data.rates; 
    }
  } catch (error) {
    console.error("Error fetching exchange rates:", error);
  }
};


export const formatCurrency = (value, currencyCode = 'NGN', sourceCurrency = 'USD') => {
  // Handle legacy calls where 3rd arg might be boolean (exchangeLoaded)
  if (typeof sourceCurrency === 'boolean') {
      sourceCurrency = 'USD';
  }
  // Default to USD if sourceCurrency is null/undefined
  if (!sourceCurrency) sourceCurrency = 'USD';

  // If rates are not loaded yet, return formatted value in source currency
  if (Object.keys(exchangeRates).length === 0) {
     return `${getCurrencySymbol(sourceCurrency)} ${value.toLocaleString()}`;
  }

  // If source and target are the same, no conversion needed
  if (currencyCode === sourceCurrency) {
    return `${getCurrencySymbol(currencyCode)} ${value.toLocaleString()}`;
  }

  // Convert source to USD first (if source is not USD)
  let valueInUSD = value;
  if (sourceCurrency !== 'USD') {
    if (exchangeRates[sourceCurrency]) {
      valueInUSD = value / exchangeRates[sourceCurrency];
    } else {
      // Fallback if source rate missing
      return `${getCurrencySymbol(sourceCurrency)} ${value.toLocaleString()}`;
    }
  }

  // Convert USD to target currency
  if (!exchangeRates[currencyCode]) {
    return `${getCurrencySymbol('USD')} ${valueInUSD.toLocaleString()}`; 
  }

  const convertedValue = valueInUSD * exchangeRates[currencyCode]; 
  return `${getCurrencySymbol(currencyCode)} ${convertedValue.toLocaleString(undefined, {
    maximumFractionDigits: 0, 
  })}`;
  
};

export const convertCurrency = (value, targetCurrency = 'NGN', sourceCurrency = 'USD') => {
  if (typeof sourceCurrency === 'boolean') sourceCurrency = 'USD';
  if (!sourceCurrency) sourceCurrency = 'USD';

  if (Object.keys(exchangeRates).length === 0) return value;
  if (targetCurrency === sourceCurrency) return value;

  let valueInUSD = value;
  if (sourceCurrency !== 'USD') {
    if (exchangeRates[sourceCurrency]) {
      valueInUSD = value / exchangeRates[sourceCurrency];
    } else {
      return value;
    }
  }

  if (!exchangeRates[targetCurrency]) return valueInUSD;

  return valueInUSD * exchangeRates[targetCurrency];
};

const getCurrencySymbol = (currencyCode) => {
  const CURRENCIES = {
    USD: "USD",  // United States Dollar
    EUR: "€",  // Euro
    GBP: "£",  // British Pound
    NGN: "NGN",  // Nigerian Naira
    JPY: "¥",  // Japanese Yen
    CAD: "CA$", // Canadian Dollar
    AUD: "A$",  // Australian Dollar
    INR: "₹",  // Indian Rupee
    CNY: "¥",  // Chinese Yuan
    BRL: "R$", // Brazilian Real
    ZAR: "R",  // South African Rand
    KES: "KSh", // Kenyan Shilling
    MXN: "Mex$", // Mexican Peso
    RUB: "₽",  // Russian Ruble
    SAR: "﷼",  // Saudi Riyal
  };

  return CURRENCIES[currencyCode] || "$"; 
};
